import React from 'react'
import { cva } from 'class-variance-authority'
import { mergeClasses } from '../../../utils/mergeClasses'

const buttonVariants = cva(
    // `tw-border-solid` is required — preflight is disabled, so a bare
    // `tw-border` only sets width and the border won't render.
    'tw-group/button tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-transparent tw-bg-clip-padding tw-text-sm tw-font-medium tw-whitespace-nowrap tw-transition-all tw-outline-none tw-select-none focus-visible:tw-border-ring focus-visible:tw-ring-[3px] focus-visible:tw-ring-ring/50 active:tw-translate-y-px disabled:tw-pointer-events-none disabled:tw-opacity-50 [&_svg]:tw-pointer-events-none [&_svg]:tw-shrink-0 [&_svg:not([class*="size-"])]:tw-size-4',
    {
        variants: {
            variant: {
                default:
                    'tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary/80',
                outline:
                    'tw-border-border tw-bg-background hover:tw-bg-muted hover:tw-text-foreground dark:tw-border-input dark:tw-bg-input/30 dark:hover:tw-bg-input/50',
                secondary:
                    'tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80',
                ghost: 'hover:tw-bg-muted hover:tw-text-foreground dark:hover:tw-bg-muted/50',
                destructive:
                    'tw-bg-destructive/10 tw-text-destructive hover:tw-bg-destructive/20 focus-visible:tw-border-destructive/40 focus-visible:tw-ring-destructive/20 dark:tw-bg-destructive/20 dark:hover:tw-bg-destructive/30 dark:focus-visible:tw-ring-destructive/40',
                link: 'tw-text-primary tw-underline-offset-4 hover:tw-underline',
            },
            size: {
                default:
                    'tw-h-8 tw-gap-1.5 tw-px-2.5 has-[[data-icon=inline-end]]:tw-pr-2 has-[[data-icon=inline-start]]:tw-pl-2',
                xs: 'tw-h-6 tw-gap-1 tw-rounded-md tw-px-2 tw-text-xs has-[[data-icon=inline-end]]:tw-pr-1.5 has-[[data-icon=inline-start]]:tw-pl-1.5 [&_svg:not([class*="size-"])]:tw-size-3',
                sm: 'tw-h-7 tw-gap-1 tw-rounded-md tw-px-2.5 tw-text-[0.8rem] has-[[data-icon=inline-end]]:tw-pr-1.5 has-[[data-icon=inline-start]]:tw-pl-1.5 [&_svg:not([class*="size-"])]:tw-size-3.5',
                lg: 'tw-h-9 tw-gap-1.5 tw-px-2.5 has-[[data-icon=inline-end]]:tw-pr-3 has-[[data-icon=inline-start]]:tw-pl-3',
                icon: 'tw-size-8',
                'icon-xs': 'tw-size-6 tw-rounded-md [&_svg:not([class*="size-"])]:tw-size-3',
                'icon-sm': 'tw-size-7 tw-rounded-md',
                'icon-lg': 'tw-size-9',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    }
)

const Button = React.forwardRef(
    ({ className, variant = 'default', size = 'default', ...props }, ref) => {
        return (
            <button
                ref={ref}
                data-slot="button"
                data-variant={variant}
                data-size={size}
                className={mergeClasses(buttonVariants({ variant, size, className }))}
                {...props}
            />
        )
    }
)
Button.displayName = 'Button'

export { Button, buttonVariants }
